import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/_admin/users/$userId/')({
	loader: async ({ params }) => {
		// Redirect to the roles tab by default
		//TODO
		throw redirect({
			to: '/users/$userId/roles',
			params: { userId: params.userId },
		});
	},
	component: () => null,
});
